import type { RouteRecordRaw } from 'vue-router'
import { PageRoutes } from 'cloud-computing-power/constants/PageRoutes'

export const CloudComputingPowerRoutes: RouteRecordRaw[] = [
  // 404 not found重定向
  {
    path: '/:pathMatch(.*)*',
    redirect: PageRoutes.Home,
  },
  {
    path: PageRoutes.Home,
    component: () => import('cloud-computing-power/views/HomeView/HomeView'),
    meta: {
      title: '首页',
    },
  },
  {
    path: PageRoutes.Cloud,
    component: () => import('cloud-computing-power/views/CloudView/CloudView'),
    meta: {
      title: '云算力',
    },
  },
  {
    path: PageRoutes.GoodDetail,
    component: () => import('cloud-computing-power/views/GoodDetail/GoodDetailView'),
    meta: {
      title: '套餐详情',
    },
  },
  {
    path: PageRoutes.Income,
    component: () => import('cloud-computing-power/views/IncomeView/IncomeView'),
    meta: {
      title: '算力收益',
    },
  },
  {
    path: PageRoutes.Calculator,
    component: () => import('cloud-computing-power/views/CalculatorView/CalculatorView'),
    meta: {
      title: '计算器',
    },
  },
  {
    path: PageRoutes.Order,
    component: () => import('cloud-computing-power/views/OrderView/OrderView'),
    meta: {
      title: '订单',
    },
  },
  {
    path: PageRoutes.OrderDetail,
    component: () => import('cloud-computing-power/views/OrderDetailView/OrderDetailView'),
    meta: {
      title: '订单详情',
    },
  },
  {
    path: PageRoutes.ServiceAgreement,
    component: () => import('cloud-computing-power/views/PolicyView/ServiceAgreement'),
    meta: {
      title: '服务协议',
    },
  },
  {
    path: PageRoutes.PrivacyPolicy,
    component: () => import('cloud-computing-power/views/PolicyView/PrivacyPolicy'),
    meta: {
      title: '隐私协议', // 隐私协议
    },
  },
  {
    path: PageRoutes.Disclaimer,
    component: () => import('cloud-computing-power/views/PolicyView/Disclaimer'),
    meta: {
      title: '免责声明', // 免责声明
    },
  },
  {
    path: PageRoutes.LegalEntity,
    component: () => import('cloud-computing-power/views/PolicyView/LegalEntity'),
    meta: {
      title: '法定实体', // 法定实体
    },
  },
]
